import { atomWithStorage } from "jotai/utils";

/**
 * When set, we won't show the nudge until this timestamp (ms).
 * null means "never dismissed" (eligible to show).
 */
export const feedbackNudgeDismissedUntilAtom = atomWithStorage<number | null>(
  "stratistics.feedbackNudge.dismissedUntil",
  null,
);

/**
 * Counts how many distinct page navigations the user has done
 */
export const pageViewsCountAtom = atomWithStorage<number>(
  "stratistics.pageViews.count",
  0,
);
